import { createAPNTagWrapper } from '@arkadium/apntag';

import { getVisibleAdUnits } from './utils'; // Import the getVisibleAdUnits function
import { DisplayAdComponent } from '../components/display-ad-component';

type APNTagWrapper = Awaited<ReturnType<typeof createAPNTagWrapper>>;

let _instance: APNTag;

export class APNTag {
  protected apntag: ReturnType<typeof createAPNTagWrapper>;
  protected adUnits: Record<string, DisplayAdComponent> = {};

  static getInstance() {
    if (!_instance) {
      _instance = new APNTag(window);
    }
    return _instance;
  }

  constructor(protected scope: any) {
    this.apntag = createAPNTagWrapper(scope, 280, { flight: 'zoneviewtest' });
    this.apntag.then((apntag) => {
      apntag.onEvent('adAvailable', (u: any) => {
        this.adUnits[u.targetId].onShow([u.targetId], u);
        this.showTag(u.targetId);
      });

      apntag.onEvent('adNoBid', (u: any) => {
        this.adUnits[u.targetId].onShow([u.targetId], u);
      });

      setInterval(() => this.requestAds(apntag), 500);
    });
  }

  // Method to determine if the page is visible
  protected isPageVisible(): boolean {
    return document.hasFocus();
  }

  public async showTag(id: string) {
    const apntag = await this.apntag;
    apntag.showTag(id);
  }

  public async defineTag(targetId: string, sizes: [number, number][], compo: any) {
    if (this.adUnits[targetId]) throw new Error(`Cannot define tag ${targetId} because it is already defined.`);
    this.adUnits[targetId] = compo;
    const apntag = await this.apntag;
    const invCode = this.getInvCode(targetId, sizes); // Determine invCode internally
    const tag = apntag.defineTag(targetId, invCode, sizes, { msft_refresh: '0' });
    return tag;
  }

  private getInvCode(targetId: string, sizes: [number, number][]): string {
    const targetIdMapping: Record<string, string> = {
      "sidebar_ad": "GPRIGHTRAIL1",
      "sidebar_ad2": "GPRIGHTRAIL2",
      "sidebar_ad3": "GPRIGHTRAIL3"
    };

    if (targetId in targetIdMapping) {
      return targetIdMapping[targetId];
    }

    for (const size of sizes) {
      const [width, height] = size;
      if ((width === 728 && height === 90) || (width === 970 && height === 90)) {
        return 'GPGAMEBAN1';
      }
      if (width === 300 && height === 250) {
        return 'GPRIGHTRAIL1';
      }
    }

    return 'GPGAMEBAN1';
  }

  protected requestAds(apntag: APNTagWrapper) {
    const now = Date.now();
    const refreshThreshold = Date.now() - 30000;

    if (!this.isPageVisible()) {
      return;
    }

    const tagsToLoad = [] as string[];
    const tagsToRefresh = [] as string[];

    getVisibleAdUnits().forEach((item: HTMLElement) => {
      const id = item.dataset.id!;
      const refreshCount = parseInt(item.dataset.refreshCount || '0');
      const refreshTime = parseInt(item.dataset.refreshTime || '0');

      if (refreshTime === 0) {
        item.dataset.refreshTime = String(now);
        return tagsToLoad.push(id);
      }

      if (refreshTime < refreshThreshold) {
        const newRefreshCount = String(refreshCount + 1);
        item.dataset.refreshTime = String(now);
        item.dataset.refreshCount = newRefreshCount;
        apntag.setKeywords(id, { msft_refresh: newRefreshCount });
        return tagsToRefresh.push(id);
      }
    });

    if (tagsToLoad.length > 0) apntag.loadTags(tagsToLoad);
    if (tagsToRefresh.length > 0) apntag.refresh(tagsToRefresh);
  }
}
